<template>
  <v-card flat class="background-card">
    <span>
      <v-tag class="px-2">
        {{ $t('message.pages.analyticsV3.resume.new') }}
      </v-tag>
    </span>
    <p class="body-bold-base brand-0--text mb-1 mt-4">
      {{ $t('message.pages.analyticsV3.resume.compareTitle') }}
    </p>

    <p class="body-regular-small neutral-20-dark--text">
      {{ $t('message.pages.analyticsV3.resume.compareDescription') }}
    </p>

    <div>
      <base-btn
        type="secondary"
        class="background-btn"
        @click="
          $router.push({
            name: 'AnalyticsV3VideoComparer',
            params: { openVideosFilterModal: true },
          })
        "
      >
        {{ $t('message.pages.analyticsV3.resume.compareButton') }}
        <v-icon size="20" class="ml-1">mdi-arrow-right</v-icon>
      </base-btn>
    </div>
  </v-card>
</template>

<script>
export default {
  name: 'BlueBanner',
  methods: {
    handleClick() {
      // Handle click event
    },
  },
}
</script>

<style lang="scss" scoped>
.background-card {
  padding: 16px;
  border-radius: 8px;
  background: varFigma(brand-95-lighter) !important;
}

.background-btn {
  background: varFigma(neutral-100-white) !important;
}
</style>
